/**
 * Document Preview — modul global pentru previzualizarea documentelor.
 *
 * Public API:
 * - `<DocumentPreviewModal>` — entry-point unic pentru orice tip
 * - `registerDocumentType` — declară un tip nou de document
 * - Tipuri: `DocumentTypeConfig`, `ToolbarAction`, `ViewerContext`
 *
 * Setup (în `apps/app/src/features/document-preview/setup.ts`):
 * ```ts
 * registerDocumentType('invoice', () => import('./types/invoice'));
 * registerDocumentType('nir', () => import('./types/nir'));
 * registerDocumentType('receipt', () => import('./types/receipt'));
 * registerDocumentType('efactura', () => import('./types/efactura'));
 * ```
 *
 * Usage (în orice pagină):
 * ```tsx
 * const [preview, setPreview] = useState<{ type: string; id: string } | null>(null);
 * <DocumentPreviewModal
 *   type={preview?.type ?? null}
 *   documentId={preview?.id ?? null}
 *   onClose={() => setPreview(null)}
 *   onRefresh={() => qc.invalidateQueries(...)}
 * />
 * ```
 */

export { DocumentPreviewModal } from './document-preview-modal';
export {
  registerDocumentType,
  resolveDocumentType,
  getRegisteredDocumentTypes,
} from './registry';
export type {
  DocumentTypeConfig,
  DocumentTypeResolver,
  ToolbarAction,
  ToolbarActionType,
  ViewerContext,
  DocumentStatusBadge,
} from './registry-types';
